import { parseJwt } from "src/shared/global/helpers";
import ManageStorage from "src/shared/global/manageStorage";

export const checkIsOwner = (user) => {
    const token = ManageStorage.getValueFromStorage("tokenUser");
    const payload = token ? parseJwt(token) : null;

    return {
        isOwner: user?.payload?.uswRut === payload?.Username,
        haveAccount: user?.payload?.uswTieneCuenta
    };
}